import { UserType } from "@prisma/client";

export const PROVIDER_SUPPORT_EMAIL = "providers@marblehealth.com";
export const GENERAL_SUPPORT_EMAIL = "hello@marblehealth.com";

export type SupportContact =
  | { kind: "email"; email: string }
  | { kind: "school-success-partner" };

/**
 * Who a user should contact when something breaks, keyed off their user type.
 * Shared by every error surface so the four audiences aren't routed to
 * different addresses depending on which boundary caught the error.
 */
export function getSupportContactForUserType(
  userType?: string | null,
): SupportContact {
  if (userType === UserType.THERAPIST) {
    return { kind: "email", email: PROVIDER_SUPPORT_EMAIL };
  }
  if (userType === UserType.SCHOOL_WORKER) {
    return { kind: "school-success-partner" };
  }
  return { kind: "email", email: GENERAL_SUPPORT_EMAIL };
}
